export default __webpack_public_path__ + "static/media/memory-card.3d2da390.png";